import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SIZES, COLORS, MQS } from '../app/common/constants/styles';
import Header from '../about/Header';
import { IReduxRootState } from '../app/reduxRootState.interface';
import FooterContainer from '../footer/FooterContainer';
import { TranslationHelpers } from '../i18n/translationHelpers';

const Container = styled.div`
    background-color: ${COLORS.ultralightGrey};
    height: 100%;
    font-family: Rakuten Sans UI Regular, sans-serif;
`;

const Content = styled.div`
    max-width: ${1 * SIZES.appMaxWidth}px;
    margin: 0px auto;
    padding: 0px 20px;

    h2 {
        font-family: Rakuten Sans UI Bold, sans-serif;
        font-size: 43px;
        margin-top: 40px;
    }

    h3 {
        font-family: Rakuten Sans UI Bold, sans-serif;
        font-size: 35px;
        margin-top: 40px;
    }

    p {
        font-size: 18px;
        line-height: 1.57;

        a {
            text-decoration: none;
            color: ${COLORS.rakutenRed};
            font-weight: bold;
        }

        b {
            font-weight: bold;
        }
    }

    ul {
        li {
            line-height: 28px;
            font-size: 18px;
        }
    }

    @media (max-width: ${MQS.mq2Min}) {
        word-break: break-word;
    }
`;

const Cookie = () => {
    const appConfig = useSelector((state: IReduxRootState) => state.app.appConfig);

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const generateLink = (link: string, text: string) => (
        <a
            href={link}
            target={link.includes('/cookie-manager') ? '_self' : '_blank'}
            rel="noopener noreferrer"
        >
            {text}
        </a>
    );

    return (
        <Container>
            <Header appConfig={appConfig} />
            <Content>
                <h2>{TranslationHelpers.getFormattedMessage('cookie.policy')}</h2>
                <p>{TranslationHelpers.getFormattedMessage('cookie.last.update')}</p>
                <p>
                    {TranslationHelpers.getFormattedMessage('cookie.description.1', {
                        link1: generateLink(
                            'https://eu.account.rakuten.com',
                            'eu.account.rakuten.com',
                        ),
                        link2: generateLink(
                            'https://global.rakuten.com/corp/about/company',
                            'https://global.rakuten.com/corp/about/company',
                        ),
                    })}
                </p>
                <p>{TranslationHelpers.getFormattedMessage('cookie.description.2')}</p>
                <p>{TranslationHelpers.getFormattedMessage('cookie.description.3')}</p>
                <p>{TranslationHelpers.getFormattedMessage('cookie.description.4')}</p>

                <h2>{TranslationHelpers.getFormattedMessage('cookie.heading.1')}</h2>
                <p>{TranslationHelpers.getFormattedMessage('cookie.heading.1.description.1')}</p>
                <p>{TranslationHelpers.getFormattedMessage('cookie.heading.1.description.2')}</p>

                <h2>{TranslationHelpers.getFormattedMessage('cookie.heading.2')}</h2>
                <p>{TranslationHelpers.getFormattedMessage('cookie.heading.2.description.1')}</p>

                <h3>{TranslationHelpers.getFormattedMessage('cookie.heading.2.subheading.1')}</h3>
                <p>
                    {TranslationHelpers.getFormattedMessage(
                        'cookie.heading.2.subheading.1.description.1',
                    )}
                </p>
                <ul>
                    <li>
                        {TranslationHelpers.getFormattedMessage(
                            'cookie.heading.2.subheading.1.point.1',
                        )}
                    </li>
                    <li>
                        {TranslationHelpers.getFormattedMessage(
                            'cookie.heading.2.subheading.1.point.2',
                        )}
                    </li>
                    <li>
                        {TranslationHelpers.getFormattedMessage(
                            'cookie.heading.2.subheading.1.point.3',
                        )}
                    </li>
                </ul>
                <h3>{TranslationHelpers.getFormattedMessage('cookie.heading.2.subheading.2')}</h3>
                <p>
                    {TranslationHelpers.getFormattedMessage(
                        'cookie.heading.2.subheading.2.description.1',
                    )}
                </p>
                <ul>
                    <li>
                        {TranslationHelpers.getFormattedMessage(
                            'cookie.heading.2.subheading.2.point.1',
                        )}
                    </li>
                </ul>

                <h2>{TranslationHelpers.getFormattedMessage('cookie.heading.3')}</h2>
                <p>
                    {TranslationHelpers.getFormattedMessage('cookie.heading.3.description.1', {
                        link1: generateLink(
                            `${window.location.origin}/cookie-manager`,
                            `${window.location.origin}/cookie-manager`,
                        ),
                    })}
                </p>

                <h3>{TranslationHelpers.getFormattedMessage('cookie.heading.4')}</h3>
                <p>{TranslationHelpers.getFormattedMessage('cookie.heading.4.description.1')}</p>

                <h3>{TranslationHelpers.getFormattedMessage('cookie.heading.5')}</h3>
                <p>
                    {TranslationHelpers.getFormattedMessage('cookie.heading.5.description.1', {
                        link1: generateLink(
                            'mailto:rakuten-privacy@mail.rakuten.com',
                            'rakuten-privacy@mail.rakuten.com',
                        ),
                    })}
                </p>
            </Content>
            <FooterContainer />
        </Container>
    );
};

export default Cookie;
